
import Failure from '../../../core/Failure';
import { Authentication } from '@leedpulse-monorepo/classes';
import HttpClient from '../../../core/HttpClient';

export interface EnhanceScenarioPayload {
  sTextToEnhance: string;
  sTextType: string;
  sOwner: string;
  sScenarioId: string;
  sIdApiKey: string | undefined;
}

export interface EnhanceScenarioResponse {
  enhanced_prompt?: string;
  detected_fixes?: {issue: string, origin: string, resolution: string}[];
}
async function enhanceScenarioAI(
  payload: EnhanceScenarioPayload,
  auth: Authentication
): Promise<EnhanceScenarioResponse> {
  try {
    const response = await HttpClient.post(
        '/scenario/enhance-ai',
        payload,
        auth.token,
    );

    if (response.success) {
        return response.data;
    } else {
        console.log('error: ', response);
        throw new Error('Error enhancing scenario with AI');
    }
} catch (e) {
    console.log('error: ', e);
    throw new Error('Error enhancing scenario with AI');
}
}

export class UpdateScenarioFailure extends Failure {
  constructor(message = 'Unknown error', code = 'unknown-error') {
    super(message, code);
  }
}

export default enhanceScenarioAI;
